import { Button, Icon } from 'semantic-ui-react';
import moment from 'src/services/moment_instance';
import { agGridDateCreatedAtFieldComparator } from 'src/components/table/helpers';

export const getRelationsTableColumns = (handleViewDetails) => [
  {
    headerName: 'Fecha',
    field: 'createdAt',
    sortable: true,
    filter: true,
    flex: 1.2,
    minWidth: 120,
    valueGetter: (params) => {
      if (!params.data.createdAt) return '-';
      return moment(params.data.createdAt).format('DD/MM/YYYY HH:mm');
    },
    comparator: agGridDateCreatedAtFieldComparator,
  },
  {
    headerName: 'Identificación',
    field: 'identification',
    sortable: true,
    filter: true,
    flex: 1.2,
    minWidth: 120,
    valueGetter: (params) => params.data?.Guest?.identification || '-',
  },
  {
    headerName: 'Nombres',
    field: 'name',
    sortable: true,
    filter: true,
    flex: 1.5,
    minWidth: 150,
    valueGetter: (params) => params.data?.Guest?.name || '-',
  },
  {
    headerName: 'Apellidos',
    field: 'lastName',
    sortable: true,
    filter: true,
    flex: 1.5,
    minWidth: 150,
    valueGetter: (params) => params.data?.Guest?.lastName || '-',
  },
  {
    headerName: 'Género',
    field: 'gender',
    sortable: true,
    filter: true,
    flex: 1,
    minWidth: 100,
    valueGetter: (params) => params.data?.Guest?.gender,
  },
  {
    headerName: 'Teléfono',
    field: 'phone',
    sortable: true,
    filter: true,
    flex: 1.2,
    minWidth: 120,
    valueGetter: (params) => {
      if (!params.data?.Guest?.phone) return '-';
      return params.data?.Guest?.phone;
    },
  },
  {
    headerName: 'Lista de espera',
    field: 'waitlist',
    sortable: true,
    filter: true,
    flex: 1,
    minWidth: 130,
    valueGetter: (params) => (params.data?.waitlist ? 'Sí' : 'No'),
  },
  {
    headerName: 'Acciones',
    field: 'actions',
    sortable: false,
    filter: false,
    flex: 1,
    minWidth: 100,
    cellRenderer: (params) => (
      <Button
        size="mini"
        primary
        onClick={() => handleViewDetails(params.data)}
        icon
        labelPosition="left"
      >
        <Icon name="eye" />
        Ver
      </Button>
    ),
  },
];
